var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { STAKEHOLDER_EMAIL } from '@sonar-software/sonar-ts-constants';
import { Form, Input } from 'antd';
const rules = [
    {
        message: STAKEHOLDER_EMAIL.VALIDATION_MESSAGE,
        pattern: STAKEHOLDER_EMAIL.PATTERN,
        required: false,
        type: 'string'
    }
];
export const StakeholderEmail = (_a) => {
    var { id, label, name = 'email' } = _a, rest = __rest(_a, ["id", "label", "name"]);
    return React.createElement(Form.Item, { id: id, label: label, name: name, rules: rules },
        React.createElement(Input, Object.assign({ placeholder: STAKEHOLDER_EMAIL.PLACEHOLDER }, rest, { type: 'text' })));
};
